// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ZC1DT","sidebar":"styles_sidebar__iens8","disabled":"styles_disabled__3CZEQ","toggle":"styles_toggle__TeGvF","icon":"styles_icon__y620j"};